import { render, staticRenderFns } from "./ButtonText.vue?vue&type=template&id=506e5ac8&"
import script from "./ButtonText.vue?vue&type=script&lang=js&"
export * from "./ButtonText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports